import { NextResponse } from "next/server";
import axios from "axios";

export async function POST(req) {
  try {
    const { accessToken } = await req.json();

    const response = await axios.get(
      "https://graph.facebook.com/v21.0/oauth/access_token",
      {
        params: {
          grant_type: "fb_exchange_token",
          client_id: process.env.FACEBOOK_CLIENT_ID,
          client_secret: process.env.FACEBOOK_SECRET_ID,
          fb_exchange_token: accessToken, // The short-lived token received after login
        },
      }
    );

    return NextResponse.json({ data: response.data });
  } catch (error) {
    console.error("Error during Instagram token exchange:", error);
    return NextResponse.json(
      { error: "Instagram token exchange failed" },
      { status: 500 }
    );
  }
}
